import { Component, Input, OnInit, ViewChild } from '@angular/core';

import { EventsBusService } from '../../shared/eventsBus.service';
import { Assignment, Feedback } from '../shared/feedbacks.model';
import { FeedbacksService } from '../shared/feedbacks.service';

@Component({
  selector: 'app-feedback-assignments',
  templateUrl: './feedback-assignments.component.html',
  styleUrls: ['./feedback-assignments.component.scss']
})
export class FeedbackAssignmentsComponent implements OnInit {
  @Input() feedback: Feedback;
  @ViewChild('inputImage') inputImage: any;
  public assignment: Assignment = {} as Assignment;
  public date = [];
  public images = [];
  constructor(private service: FeedbacksService, private eventsBus: EventsBusService) {}

  ngOnInit() {}

  public removeImage(images, i) {
    images.splice(i, 1);
  }

  public changeListener(e): void {
    this.readFiles(e.target);
    this.inputImage.nativeElement.value = '';
  }

  private readFiles(inputValue: any): void {
    const num = inputValue.files.length;
    for (let i = 0; i < num; i++) {
      const file: File = inputValue.files[i];
      const myReader: FileReader = new FileReader();
      myReader.onloadend = e => {
        this.snapshotResize(myReader.result);
      };
      myReader.readAsDataURL(file);
    }
  }

  snapshotResize(base64) {
    // Max size for thumbnail
    const maxWidth = 500;
    const maxHeight = 500;

    // Create and initialize two canvas
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    const canvasCopy = document.createElement('canvas');
    const copyContext = canvasCopy.getContext('2d');

    // Create original image
    const img = new Image();
    img.src = base64;
    img.onload = () => {
      // Determine new ratio based on max size
      let ratio = 1;
      if (img.width > maxWidth) {
        ratio = maxWidth / img.width;
      } else if (img.height > maxHeight) {
        ratio = maxHeight / img.height;
      }

      // Draw original image in second canvas
      canvasCopy.width = img.width;
      canvasCopy.height = img.height;
      copyContext.drawImage(img, 0, 0);

      // Copy and resize second canvas to first canvas
      canvas.width = img.width * ratio;
      canvas.height = img.height * ratio;
      ctx.drawImage(canvasCopy, 0, 0, canvasCopy.width, canvasCopy.height, 0, 0, canvas.width, canvas.height);
      canvas.toDataURL();
      this.images.push(canvas.toDataURL('image/jpeg'));
    };
  }

  public assign(fb: Feedback, action: string, assignment: Assignment) {
    assignment.asImages = this.images;
    this.service.assign(fb._id, action, assignment).subscribe((feedback: Feedback) => {
      this.feedback = feedback;
      this.eventsBus.updateFeedback.emit();
      this.images = [];
      assignment.asMessage = '';
      assignment.asImages = [];
    }, console.error);
  }
}



// WEBPACK FOOTER //
// /ng-app/src/app/feedbacks/feedback-assignments/feedback-assignments.component.ts